import {createAction, props} from '@ngrx/store';
import {InformationUnitModel} from '@core/modules/rest/informationunit/response/information-unit.model';
import {UpdateInformationUnitModel} from '@core/modules/rest/informationunit/request/update-information-unit.model';
import {IndicationUnitsRequestModel} from '@core/modules/rest/consent/request/indication-units-request.model';
import {LanguageEnum} from '@core/enums/language.enum';
import {OutlineUnitBasicModel} from '@core/modules/rest/consent/response/outline-unit-basic.model';
import {ChangeUnitLevelRequestModel} from '@core/modules/rest/informationunit/request/change-unit-level-request.model';
import {DeleteUnitRequestModel} from '@core/modules/rest/consent/request/delete-unit-request.model';
import {ChangeUnitOrderModel} from '@core/modules/rest/informationunit/request/change-unit-order.model';
import {ChangeUnitRelevanceRequestModel} from '@core/modules/rest/informationunit/request/change-unit-relevance-request.model';

export const GetInformationUnit = createAction(
    '[CMS] Get information unit',
    props<{ unitId: string }>()
);

export const GetInformationUnitSuccess = createAction(
    '[CMS] Get information unit success',
    props<{ unit: InformationUnitModel }>()
);

export const SaveInformationUnit = createAction(
    '[CMS] Save information unit',
    props<{ saveUnitRequest: UpdateInformationUnitModel, executed: (unit: InformationUnitModel) => void }>()
);

export const SaveInformationUnitSuccess = createAction(
    '[CMS] Save information unit success',
    props<{ unit: InformationUnitModel }>()
);

export const ResetEditorInfo = createAction(
    '[CMS] Reset editor info'
);

export const ResetInformationUnitInfo = createAction(
    '[CMS] Reset information unit info'
);

export const GetCMSOutline = createAction(
    '[CMS] Get cms outline',
    props<{ request: IndicationUnitsRequestModel }>()
);

export const GetCMSOutlineSuccess = createAction(
    '[CMS] Get cms outline success',
    props<{ outline: OutlineUnitBasicModel[] }>()
);

export const CreateNewUnitInOutline = createAction(
    '[CMS] Create new unit in outline',
    props<{ unit: InformationUnitModel, indicationId: string, language: LanguageEnum }>()
);

export const UpdateUnitInOutline = createAction(
    '[CMS] Update unit in outline',
    props<{ unit: InformationUnitModel, language: LanguageEnum }>()
);

export const MoveUnitLevelDown = createAction(
    '[CMS] Move unit level down',
    props<{ request: ChangeUnitLevelRequestModel }>()
);

export const MoveUnitLevelDownSuccess = createAction(
    '[CMS] Move unit level down success',
    props<{ units: OutlineUnitBasicModel[] }>()
);

export const MoveUnitLevelUp = createAction(
    '[CMS] Move unit level up',
    props<{ request: ChangeUnitLevelRequestModel }>()
);

export const MoveUnitLevelUpSuccess = createAction(
    '[CMS] Move unit level up success',
    props<{ units: OutlineUnitBasicModel[] }>()
);

export const ReorderUnits = createAction(
    '[CMS] Reorder units',
    props<{ request: ChangeUnitOrderModel }>()
);

export const ReorderUnitsSuccess = createAction(
    '[CMS] Reorder units success',
    props<{ units: OutlineUnitBasicModel[] }>()
);

export const DeleteUnit = createAction(
    '[CMS] Delete unit',
    props<{ request: DeleteUnitRequestModel }>()
);

export const DeleteUnitSuccess = createAction(
    '[CMS] Delete unit success',
    props<{ units: OutlineUnitBasicModel[] }>()
);

export const ChangeUnitRelevance = createAction(
    '[CMS] Change unit relevance',
    props<{ request: ChangeUnitRelevanceRequestModel }>()
);

export const ChangeUnitRelevanceSuccess = createAction(
    '[CMS] Change unit relevance success'
);
